import { css, fillOutlined, circle, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const BRASS = 0xc89b54; // clockwork brass
const FACE = 0x2a2440; // dark clock face

/**
 * B15 Chronos — a clockwork orb of nested gear rings around a dark
 * clock face. It seeds time-warp zones across the arena. docs/02 boss pool.
 */
export const bossChronosBody: ProceduralDef = {
  key: 'boss/chronos/body',
  width: 150,
  height: 150,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 1,
  draw(ctx, w, h) {
    const c = w / 2;

    // Brass halo
    const halo = ctx.createRadialGradient(c, c, 16, c, c, c);
    halo.addColorStop(0, 'rgba(200,155,84,0.32)');
    halo.addColorStop(1, 'rgba(200,155,84,0)');
    circle(ctx, c, c, c);
    ctx.fillStyle = halo;
    ctx.fill();

    // Outer gear ring with teeth
    const teeth = 16;
    const rOut = 56;
    ctx.beginPath();
    for (let i = 0; i < teeth; i++) {
      const a0 = (Math.PI * 2 * i) / teeth;
      const a1 = (Math.PI * 2 * (i + 0.5)) / teeth;
      ctx.lineTo(c + Math.cos(a0) * rOut, c + Math.sin(a0) * rOut);
      ctx.lineTo(c + Math.cos(a1) * (rOut - 9), c + Math.sin(a1) * (rOut - 9));
    }
    ctx.closePath();
    fillOutlined(ctx, BRASS, 5);

    // Inner gear ring
    circle(ctx, c, c, 40);
    fillOutlined(ctx, shade(BRASS, 0.8), 4);

    // Clock face
    circle(ctx, c, c, 30);
    fillOutlined(ctx, FACE, 4);

    // Hour ticks
    ctx.strokeStyle = css(BRASS);
    ctx.lineWidth = 2;
    for (let i = 0; i < 12; i++) {
      const a = (Math.PI * 2 * i) / 12;
      ctx.beginPath();
      ctx.moveTo(c + Math.cos(a) * 26, c + Math.sin(a) * 26);
      ctx.lineTo(c + Math.cos(a) * 29, c + Math.sin(a) * 29);
      ctx.stroke();
    }

    // Clock hands
    ctx.strokeStyle = css(0xeaddc0);
    ctx.lineCap = 'round';
    ctx.lineWidth = 3.5;
    ctx.beginPath();
    ctx.moveTo(c, c);
    ctx.lineTo(c + 14, c - 6);
    ctx.moveTo(c, c);
    ctx.lineTo(c - 4, c - 20);
    ctx.stroke();
    circle(ctx, c, c, 4);
    ctx.fillStyle = css(BRASS);
    ctx.fill();
    void h;
  },
};
